import * as PIXI from "pixi.js";
import { WinDisplayLandscapeProperties } from "../landscape/WinDisplayLandscapeProperties";
/**
 * WinDisplayPortraitProperties.ts
 */
export class WinDisplayPortraitProperties extends WinDisplayLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.gameOverProperties.position = new PIXI.Point(60, 650);
        this.scale.set(1);
    }
}
